<template>
    <v-container>
        <v-row>
            <!-- Page Header -->
            <v-col
                class="col col-md-12"
                :style="{'padding' : $vuetify.breakpoint.mobile ? '32px 0px':'12px 0px'}"
            >
                <v-toolbar flat>
                    <div
                        v-if="!$vuetify.breakpoint.mobile && getTicketRevisionDetails"
                        class="d-flex justify-space-between align-center"
                    >
                        <v-btn
                            icon
                            class="btn-back"
                            @click="backTicketDetails()"
                        >
                            <v-icon class="material-icons-outlined">
                                chevron_left
                            </v-icon>
                        </v-btn>
                        <v-toolbar-title
                            class="pl-3"
                        >
                            Revisions
                        </v-toolbar-title>
                        <v-chip
                            class="ml-2 text-caption ticket-chip"
                            outlined
                        >
                            {{ getTicketRevisionDetails ? getTicketRevisionDetails.length : 0 }}
                        </v-chip>
                    </div>

                    <div
                        v-for="(revision, index) in getTicketRevisionDetails"
                        :key="revision.id"
                    >
                        <div
                            v-if="$vuetify.breakpoint.mobile && getTicketRevisionDetails && (active_tab === index)"
                            class="d-flex align-center"
                        >
                            <v-btn
                                icon
                                class="btn-back"
                                @click="backTicketDetails()"
                            >
                                <v-icon class="material-icons-outlined">
                                    chevron_left
                                </v-icon>
                            </v-btn>
                            <v-toolbar-title
                                class="pl-3"
                                ng-if="revision"
                            >
                                {{ revision.Tickets.ticket }}-{{ revision.Tickets.revision }}
                            </v-toolbar-title>
                            <v-chip
                                link
                                outlined
                                pill
                                class="ml-5"
                                ng-if="revision"
                                :class="ticketStatus[revision.Ticket_Status.stage].class"
                            >
                                {{ ticketStatus[revision.Ticket_Status.stage].status }}
                            </v-chip>
                        </div>
                        <div v-if="$vuetify.breakpoint.mobile && getTicketRevisionDetails && (active_tab === index)">
                            <v-chip
                                v-if="revision.Tickets.center"
                                label
                                outlined
                                class="ml-2"
                            >
                                {{ revision.Tickets.center }}
                            </v-chip>
                            <v-chip
                                v-if="revision.Tickets.priority"
                                label
                                outlined
                                class="ml-2"
                            >
                                <v-icon
                                    small
                                    class="mr-1"
                                >
                                    info
                                </v-icon>
                                {{ revision.Tickets.priority }}
                            </v-chip>
                            <v-chip
                                v-if="revision.Tickets.type"
                                label
                                outlined
                                class="ml-2"
                            >
                                {{ revision.Tickets.type }}
                            </v-chip>
                            <v-chip
                                v-if="revision.Tickets.category"
                                label
                                outlined
                                class="ml-2"
                            >
                                {{ revision.Tickets.category }}
                            </v-chip>
                            <v-chip
                                v-if="revision.Tickets.duedate"
                                label
                                outlined
                                class="ml-2"
                            >
                                {{ dueDateText(revision.Tickets.duedate) }}
                            </v-chip>
                        </div>
                    </div>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-divider class="mt-5" />
        <v-tabs
            id="revisions-tabs-container"
            v-model="active_tab"
            :class="$vuetify.breakpoint.mobile ? 'revisions-mobile-tabs-container':''"
            :vertical="$vuetify.breakpoint.mobile ? false : true"
            show-arrows
        >
            <v-tab
                v-for="revision in getTicketRevisionDetails"
                :key="revision.id"
            >
                {{ revision.Tickets.ticket }}-{{ revision.Tickets.revision }}
            </v-tab>
            <v-tab-item
                v-for="revision in getTicketRevisionDetails"
                :key="revision.id"
            >
                <v-card flat>
                    <v-card-text>
                        <v-row v-show="!$vuetify.breakpoint.mobile">
                            <v-col
                                class="col col-md-12"
                                style="padding: 8px 0px 0px 0px;"
                            >
                                <v-toolbar flat>
                                    <div
                                        style="width: 100%;"
                                        class="d-flex justify-space-between"
                                    >
                                        <div class="d-flex justify-space-between">
                                            <v-toolbar-title
                                                class="pl-3"
                                            >
                                                {{ revision.Tickets.ticket }}-{{ revision.Tickets.revision }}
                                            </v-toolbar-title>
                                            <v-chip
                                                link
                                                outlined
                                                pill
                                                class="ml-5"
                                                :class="ticketStatus[revision.Ticket_Status.stage].class"
                                            >
                                                {{ ticketStatus[revision.Ticket_Status.stage].status }}
                                            </v-chip>
                                        </div>
                                        <div>
                                            <v-btn
                                                class="ma-1 action-btn text-subtitle-2"
                                                depressed
                                                color="primary"
                                                @click="assign"
                                            >
                                                <v-icon
                                                    left
                                                    dark
                                                    class="material-icons-outlined action-icon"
                                                >
                                                    assignment_turned_in
                                                </v-icon>
                                                Assign
                                            </v-btn>
                                        </div>
                                    </div>
                                </v-toolbar>
                            </v-col>
                        </v-row>
                        <v-row v-show="!$vuetify.breakpoint.mobile">
                            <v-chip
                                v-if="revision.Tickets.center"
                                label
                                outlined
                                class="ml-2"
                            >
                                {{ revision.Tickets.center }}
                            </v-chip>
                            <v-chip
                                v-if="revision.Tickets.priority"
                                label
                                outlined
                                class="ml-2"
                            >
                                <v-icon
                                    small
                                    class="mr-1"
                                >
                                    info
                                </v-icon>
                                {{ revision.Tickets.priority }}
                            </v-chip>
                            <v-chip
                                v-if="revision.Tickets.type"
                                label
                                outlined
                                class="ml-2"
                            >
                                {{ revision.Tickets.type }}
                            </v-chip>
                            <v-chip
                                v-if="revision.Tickets.category"
                                label
                                outlined
                                class="ml-2"
                            >
                                {{ revision.Tickets.category }}
                            </v-chip>
                            <v-chip
                                v-if="revision.Tickets.duedate"
                                label
                                outlined
                                class="ml-2"
                            >
                                {{ dueDateText(revision.Tickets.duedate) }}
                            </v-chip>
                        </v-row>
                        <v-row v-show="!$vuetify.breakpoint.mobile">
                            <v-divider class="my-3" />
                        </v-row>

                        <v-row
                            class="my-5 d-flex flex-column"
                            :class="$vuetify.breakpoint.mobile ? 'mx-2' : 'mx-5'"
                        >
                            <div class="mb-5">
                                <h4>
                                    Overview
                                </h4>
                            </div>
                            <table class="custom-revisions-data-table">
                                <tbody>
                                    <tr>
                                        <td>Company Name : </td>
                                        <td><b>{{ revision.Tickets.company }}</b></td>
                                    </tr>
                                    <tr>
                                        <td>Site Contact: </td>
                                        <td><b> {{ revision.Tickets.contact_name != "" ? revision.Tickets.contact_name: revision.Tickets.caller }}</b></td>
                                    </tr>
                                    <tr>
                                        <td>Site Phone : </td>
                                        <td><b>{{ revision.Tickets.contact_phone ? formatPhone(revision.Tickets.contact_phone) : formatPhone(revision.Tickets.caller_phone) }}</b></td>
                                    </tr>
                                    <tr>
                                        <td>Site SMS/Cell : </td>
                                        <td><b>{{ revision.Tickets.contact_phone_alt ? revision.Tickets.contact_phone_alt: emptyString }}</b></td>
                                    </tr>
                                    <tr>
                                        <td>Work Type : </td>
                                        <td><b>{{ revision.Tickets.work_type }}</b></td>
                                    </tr>
                                    <tr>
                                        <td>Additional : </td>
                                        <td>
                                            <div>
                                                <v-chip
                                                    v-if="showExplosives(revision.Tickets.explosives)" 
                                                    pill
                                                    outlined
                                                    :color="getExplosivesColor(revision.Tickets.explosives)"
                                                    class="detail-chip"
                                                >
                                                    Explosives
                                                </v-chip>
                                                <v-chip
                                                    v-if="showBoring(revision.Tickets.boring)"
                                                    pill
                                                    outlined
                                                    :color="
                                                        getBoringColor(revision.Tickets.boring)"
                                                    class="detail-chip"
                                                >
                                                    Boring
                                                </v-chip>                                    
                                                <v-chip
                                                    v-if="showVacuum(revision.Tickets.vacuum)" 
                                                    outlined
                                                    :color="getVacuumColor(revision.Tickets.vacuum)"
                                                    class="detail-chip"
                                                >
                                                    Vacuum
                                                </v-chip>                                   
                                                <v-chip
                                                    v-if="showPremarked(revision.Tickets.delineated, revision.Tickets.whitelined)" 
                                                    pill
                                                    outlined
                                                    :color="getPremarkedColor(revision.Tickets.delineated)"                                   
                                                    class="detail-chip"
                                                >
                                                    Pre-Marked
                                                </v-chip>
                                                <v-chip
                                                    v-if="showMeet(revision.Tickets.meet)" 
                                                    pill
                                                    outlined
                                                    :color="getMeetColor(revision.Tickets.meet)"
                                                    class="detail-chip"
                                                >
                                                    Meet
                                                </v-chip>                                  
                                                <v-chip
                                                    v-if="showLegal(revision.Tickets.legal)" 
                                                    pill
                                                    outlined
                                                    :color="getLegalColor(revision.Tickets.legal)"
                                                    class="detail-chip"
                                                >
                                                    Legal
                                                </v-chip> 
                                                <v-chip
                                                    v-if="showRemark(revision.Tickets.remark)" 
                                                    pill
                                                    outlined
                                                    :color="getRemarkColor(revision.Tickets.remark)"
                                                    class="detail-chip"
                                                >
                                                    Re-Mark
                                                </v-chip>
                                                <v-chip
                                                    v-if="showExtendedJob(revision.Tickets.extended_job)" 
                                                    pill
                                                    outlined
                                                    :color="getExtendedJobColor(revision.Tickets.extended_job)"
                                                    class="detail-chip"
                                                >
                                                    Extended Job
                                                </v-chip>
                                                <v-chip
                                                    v-if="showNight(revision.Tickets.night)" 
                                                    pill
                                                    outlined
                                                    :color="getNightColor(revision.Tickets.night)"
                                                    class="detail-chip"
                                                >
                                                    Night
                                                </v-chip>
                                                <v-chip
                                                    v-if="showWeekend(revision.Tickets.weekend)" 
                                                    pill
                                                    outlined
                                                    :color="getWeekendColor(revision.Tickets.weekend)"
                                                    class="detail-chip"
                                                >
                                                    Weekend
                                                </v-chip>
                                                <v-chip
                                                    v-if="showExcavStSidewalk(revision.Tickets.excav_st_sidewalk)" 
                                                    pill
                                                    outlined
                                                    :color="getExcavStSidewalkColor(revision.Tickets.excav_st_sidewalk)"
                                                    class="detail-chip"
                                                >
                                                    St/Sidewalk
                                                </v-chip>
                                                <v-chip
                                                    v-if="showDigInRoad(revision.Tickets.dig_in_road)" 
                                                    pill
                                                    outlined
                                                    :color="getDigInRoadColor(revision.Tickets.dig_in_road)"
                                                    class="ma-1 detail-chip"
                                                >
                                                    Dig In Road
                                                </v-chip>
                                                <v-chip
                                                    v-if="showOneYear(revision.Tickets.one_year)" 
                                                    pill
                                                    outlined
                                                    :color="getOneYearColor(revision.Tickets.one_year)"
                                                    class="ml-1 detail-chip"
                                                >
                                                    1 Year
                                                </v-chip>
                                                <v-chip
                                                    v-if="showRailroad(revision.Tickets.railroad)" 
                                                    pill
                                                    outlined
                                                    :color="getRailroadColor(revision.Tickets.railroad)"
                                                    class="ml-1 detail-chip"
                                                >
                                                    Railroad
                                                </v-chip>
                                            </div>
                                        </td>                     
                                    </tr>
                                    <tr>
                                        <td>Done For : </td>
                                        <td><b>{{ revision.Tickets.donefor }}</b></td>
                                    </tr>
                                    <tr>
                                        <td>Address : </td>
                                        <td><b>{{ revision.Tickets.full_address }}</b></td>
                                    </tr>
                                    <tr>
                                        <td>Location : </td>
                                        <td><b>{{ revision.Tickets.location }}</b></td>
                                    </tr>
                                    <tr>
                                        <td>Due Date : </td>
                                        <td><b>{{ formateDate(revision.Tickets.duedate) }}</b></td>
                                    </tr>
                                    <tr>
                                        <td>Work Date : </td>
                                        <td><b>{{ formateDate(revision.Tickets.work_date) }}</b></td>
                                    </tr>
                                    <tr v-if="revision.Tickets.work_end_date && revision.Tickets.work_end_date.length">
                                        <td>Work Ends : </td>
                                        <td><b>{{ formateDate(revision.Tickets.work_end_date) }}</b></td>
                                    </tr>
                                </tbody>
                            </table>
                        </v-row>

                        <v-row
                            :style="{'margin-bottom': $vuetify.breakpoint.xs ? '80px' : '', 'margin': !$vuetify.breakpoint.mobile ? '0px 20px' : ''}"
                        >
                            <v-expansion-panels
                                v-model="openedPanel"
                                :style="{'z-index': $vuetify.breakpoint.xs ? '6' : '1'}"
                            >
                                <v-expansion-panel>
                                    <v-expansion-panel-header>
                                        <span>Responses</span>
                                        <v-chip
                                            class="ml-2 text-caption ticket-chip"
                                            outlined
                                        >
                                            {{ revision ? revision.Ticket_Responses.length : 0 }}
                                        </v-chip>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content :class="$vuetify.breakpoint.xs ? 'expandable-mobile-view' : ''">
                                        <v-card
                                            v-if="$vuetify.breakpoint.xs"
                                            class="mobile-view-header"
                                        >
                                            <v-btn
                                                icon
                                                class="btn-back"
                                                @click="closeAllPanels"
                                            >
                                                <v-icon class="material-icons-outlined">
                                                    chevron_left
                                                </v-icon>
                                            </v-btn>
                                            <h4>Responses</h4>
                                            <v-chip
                                                v-if="revision"
                                                class="ml-2 text-caption ticket-chip"
                                                outlined
                                            >
                                                {{ revision ? revision.Ticket_Responses.length : 0 }}
                                            </v-chip>
                                        </v-card>
                                        <v-container style="padding: 1px 0px;">
                                            <v-card
                                                v-for="response in revision.Ticket_Responses"
                                                :key="response.id"
                                                class="responses-revisions-container"                                               
                                                outlined
                                            >
                                                <v-row class="mx-2 mb-2 d-flex flex-column">
                                                    <div class="custom-revisions-header">
                                                        <div>
                                                            <v-icon color="yellow">
                                                                mdi-rectangle
                                                            </v-icon>
                                                            <span>{{ response.member_code }}</span>
                                                        </div>
                                                        <div v-if="!$vuetify.breakpoint.xs">
                                                            <v-btn
                                                                class="ma-1 text-subtitle-2"
                                                                outlined
                                                                light
                                                                @click="assign"
                                                            >
                                                                <v-icon
                                                                    left
                                                                    dark
                                                                    class="material-icons-outlined action-icon"
                                                                >
                                                                    assignment_turned_in
                                                                </v-icon>
                                                                Assign
                                                            </v-btn>
                                                        </div>
                                                        <div v-if="$vuetify.breakpoint.xs">
                                                            <v-icon
                                                                left
                                                                dark
                                                                class="material-icons-outlined action-icon"
                                                                style="color: var(--ll-text-brand)"
                                                                @click="assign"
                                                            >
                                                                assignment_turned_in
                                                            </v-icon>
                                                        </div>
                                                    </div>
                                                    <table class="custom-responses-data-table"> 
                                                        <tbody>
                                                            <tr>
                                                                <td>Status : </td>
                                                                <td>{{ response.stage === 'CT' ? 'CLOSED' : 'OPEN' }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Locator : </td>
                                                                <td>{{ response.locator ? getLocator(response.locator) : '-' }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Response : </td>
                                                                <td> {{ response.response_code !== '' ? response.response_code : '(No Response)' }} </td>
                                                            </tr>
                                                            <tr v-show="response.response_code.length!==0">
                                                                <td>Response by : </td>
                                                                <td><span> {{ response.response_by !== '' ? response.response_by : '' }} </span></td>
                                                            </tr>
                                                            <tr v-show="response.response_date">
                                                                <td>Response Date : </td>
                                                                <td> {{ response.response_date !== '' ? formateDate(response.response_date) : '' }} </td>
                                                            </tr>
                                                            <tr v-show="response.date_located">
                                                                <td>Date Located : </td>
                                                                <td> {{ response.date_located !== '' ? formateDate(response.date_located): '' }} </td>
                                                            </tr>
                                                            <tr v-show="response.units_marked_count">
                                                                <td>Units Marked : </td>
                                                                <td> {{ response.units_marked_count !== '' ? response.units_marked_count : '' }} </td>
                                                            </tr>
                                                            <tr v-show="response.units_worked_count">
                                                                <td>Time Worked : </td>
                                                                <td> {{ response.units_worked_count !== '' ? formatCurrentUnitsWorked(response.units_worked_count): '' }} </td>
                                                            </tr>
                                                            <tr v-show="response.excav_note">
                                                                <td>Note to Excavator : </td>
                                                                <td> {{ response.excav_note !== '' ? response.excav_note : '(No Response)' }} </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </v-row>
                                            </v-card>
                                        </v-container>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                                <v-expansion-panel>
                                    <v-expansion-panel-header>
                                        <span>Original Ticket</span>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content :class="$vuetify.breakpoint.xs ? 'expandable-mobile-view' : ''">
                                        <v-card
                                            v-if="$vuetify.breakpoint.xs"
                                            class="mobile-view-header"
                                        >
                                            <v-btn
                                                icon
                                                class="btn-back"
                                                @click="closeAllPanels"
                                            >
                                                <v-icon class="material-icons-outlined">
                                                    chevron_left
                                                </v-icon>
                                            </v-btn>
                                            <h4>Original Ticket</h4>
                                        </v-card>
                                        <v-container style="padding: 16px;">
                                            <v-row class="original-ticket-container">
                                                <v-col
                                                    class="d-flex"
                                                    cols="6"
                                                    sm="3"
                                                >
                                                    <v-select
                                                        v-model="selectedMemberCode"
                                                        label="Member Code"
                                                        :items="revision.Ticket_Text"
                                                        item-text="member_code"
                                                        return-object
                                                        dense
                                                        outlined
                                                    />
                                                </v-col>
                                                <v-col>
                                                    <v-btn
                                                        class="ma-1 text-subtitle-2 float-right"
                                                        outlined
                                                        light
                                                        :href="revision.Tickets.url"
                                                        target="_blank"
                                                    >
                                                        View {{ revision ? revision.Tickets.center : '' }} Link
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <pre
                                                    v-if="selectedMemberCode"
                                                    class="px-5 ticket-details"
                                                    v-text="selectedMemberCode.ticket_body"
                                                />
                                            </v-row>
                                        </v-container>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-tab-item>
        </v-tabs>
        <TicketsAssignDialog
            :selected-tickets="actionTickets"
            :show="showTicketsAssignDialog"
            :select-all-members="true"
            @close-assign-dialog="closeAssign"
            @assign-success="assignSuccess"
        />
    </v-container>
</template>

<script>
import webtmsBackend from '@/services/webtmsBackend';
import moment from 'moment';

import TicketsAssignDialog from '../TicketsAssignDialog.vue';
import { formatPhone } from '@/utils/phone';
import { guidEqual } from '@/utils/guid.js';

export default { 
    components: {
        TicketsAssignDialog,
    },
    data: () => ({
        active_tab: 0,
        selectedMemberCode: null,
        openedPanel: null,
        showTicketsAssignDialog: false,
        ticketStatus: {
            IL: { status: 'INITIAL LOADING', class: 'ticket-status-loading' },
            GC: { status: 'LOADING (Geocoding)', class: 'ticket-status-loading' },
            AC: { status: 'LOADING (Auto-Respond)', class: 'ticket-status-loading' },
            AA: { status: 'LOADING (Auto-Assign)', class: 'ticket-status-loading' },
            OP: { status: 'OPEN', class: 'ticket-status-open' },
            CT: { status: 'CLOSED', class: 'ticket-status-closed' },
        },
        emptyString: 'NOT PROVIDED',
        default_color: 'green',
    }),
    computed: {
        getTicketDetails() {
            return this.$store.getters.ticketDetails;
        },
        getTicketRevisionDetails() {
            let revisionDetails = this.$store.getters.revisionDetails;
            if(revisionDetails && revisionDetails.length>0) {
                return revisionDetails.map((item, index) => {
                    item.id = index;
                    return item;
                });
            } else {
                return [];
            }
        },
        getTickets() {
            return this.$store.getters.revisionDetails.Tickets;
        },
        actionTickets() {
            let actionTickets = [];
            if(this.getTicketRevisionDetails) {
                let details = this.getTicketRevisionDetails[this.active_tab];
                if(details) {
                    let responses = details.Ticket_Responses || [];
                    for(let response of responses) {
                        let actionTicket = Object.assign({}, details.Tickets);
                        let ticketStatus = details.Ticket_Status;
                        for(let key in ticketStatus) {
                            actionTicket['TS_'+key] = ticketStatus[key];
                        }
                        for(let key in response) {
                            actionTicket['TR_'+key] = response[key];
                        }
                        actionTickets.push(actionTicket);
                    }
                }
            }
            return actionTickets;
        },
    },
    watch: { 
        getTicketRevisionDetails: {
            immediate: true,
            handler() {
                if(this.getTicketRevisionDetails) {
                    if(this.getTicketRevisionDetails[this.active_tab]) {
                        if(this.getTicketRevisionDetails[this.active_tab].Ticket_Text) {
                            if(this.getTicketRevisionDetails[this.active_tab].Ticket_Text.length) {
                                this.selectedMemberCode = this.getTicketRevisionDetails[this.active_tab].Ticket_Text[0];
                            }
                        }
                    }
                }
            }
        }
    },
    async created() {
        this.loadTicketRevisionDetails();
    },
    methods: {
        async loadTicketRevisionDetails() {
            if(this.getTicketDetails.revisions) {
                let revisionsDetails = [];
                this.getTicketDetails.revisions.map(async (item, index) => {
                    let ticketRevisionDetails = await webtmsBackend.getTicketDetails(item.tid);
                    if(ticketRevisionDetails) {
                        revisionsDetails.push(ticketRevisionDetails);
                        if(index + 1 === this.getTicketDetails.revisions.length) {
                            if(guidEqual(item.tid, this.$route.query.tid)) {
                                this.active_tab = index;
                            }
                            this.$store.commit('SET_REVISION_DETAILS', revisionsDetails);
                        }
                    }
                });
            }
        },
        formateDate(date) {
            return moment(date).format('DD MMM YYYY, hh:mm a');
        },
        fromNow(date) {
            return moment(date).fromNow();
        },
        dueDateText(duedate) {
            const now = new Date();
            if (duedate) {
                const d = Date.parse(duedate);
                if (d <= now) {
                    return 'Overdue';
                }
                const diff = d - now;
                const hr = 1 + Math.floor(diff / 3600000);
                return '<' + hr + 'Hr';
            }
            return '?UNKNOWN';
        },
        updateTicket(result) {
            for(let ticket of result.tickets) {
                if(ticket.result.result !== 'OK') {
                    console.error('updateTicket failed with error ', ticket.result);
                }
            }
            this.loadTicketRevisionDetails();
        },
        assign() {
            this.showTicketsAssignDialog = true;
        },
        closeAssign() {
            this.showTicketsAssignDialog = false;
        },
        assignSuccess(result) {
            this.updateTicket(result);
            this.closeAssign();
        },
        formatPhone(phone) {
            if(phone) {
                return formatPhone(phone);
            }
            return phone;
        },        
        showExplosives(explosives) {
            // Possible values: Y, U, N, ?
            if(explosives === 'Y') {
                return true;
            } else {
                return false;
            }
        },        
        getExplosivesColor() {
            // Possible values: Y, U, N, ?
            return this.default_color;
        },
        getDefaultColor() {
            return this.default_color;
        },
        showVacuum(vacuum) {
            // Possible values: Y, N, ?
            if(vacuum === 'Y') {
                return true;
            } else {
                return false;
            }
        },
        getVacuumColor() {
            // Possible values: Y, N, ?
            return this.default_color;
        },  
        showBoring(boring) {
            // Possible values: D, H, Y, N, ? // Unknown what D and H mean 
            if(boring === 'Y') {
                return true;
            } else {
                return false;
            }
        },
        getBoringColor() {
            // Possible values: D, H, Y, N, ? // Unknown what D and H mean  
            return this.default_color;
        },   
        showMeet(meet) {
            // Possible values: Y, N, ? 
            if(meet === 'Y') {
                return true;
            } else {
                return false;
            }
        },
        getMeetColor() {
            return this.default_color;
        },     
        showLegal(legal) {
            // Possible values: Y, N, ?
            //  Note: Legal value of N is what we want to alert the user to  
            if(legal === 'N') {
                return true;
            } else {
                return false;
            }
        },
        getLegalColor(legal) {
            // Possible values: Y, N, ?  
            if(legal === 'N') {
                return 'red';
            } else {
                return this.default_color;
            }
        },
        showRemark(remark) {
            // Possible values: Y, N, ?  
            if(remark === 'Y') {
                return true;
            } else {
                return false;
            }
        },
        getRemarkColor() {
            // Possible values: Y, N, ?  
            return this.default_color;
        },
        showExtendedJob(extendedJob) {
            // Possible values: Y, N, ?  
            if(extendedJob === 'Y') {
                return true;
            } else {
                return false;
            }
        },
        getExtendedJobColor() {
            // Possible values: Y, N, ?  
            return this.default_color;
        },
        showNight(night) {
            // Possible values: Y, N, ?  
            if(night === 'Y') {
                return true;
            } else {
                return false;
            }
        },
        getNightColor() {
            // Possible values: Y, N, ?  
            return this.default_color;
        },
        showWeekend(weekend) {
            // Possible values: Y, N, ?  
            if(weekend === 'Y') {
                return true;
            } else {
                return false;
            }
        },
        getWeekendColor() {
            // Possible values: Y, N, ?  
            return this.default_color;
        },     
        showExcavStSidewalk(excavStSidewalk) {
            // Possible values: Y, N, ?  
            if(excavStSidewalk === 'Y') {
                return true;
            } else {
                return false;
            }
        },
        getExcavStSidewalkColor() {
            // Possible values: Y, N, ?  
            return this.default_color;
        },      
        showDigInRoad(digInRoad) {
            // Possible values: Y, N, ?  
            if(digInRoad === 'Y') {
                return true;
            } else {
                return false;
            }
        },
        getDigInRoadColor() {
            // Possible values: Y, N, ?  
            return this.default_color;
        },
        showOneYear(oneYear) {
            // Possible values: Y, N, ?  
            if(oneYear === 'Y') {
                return true;
            } else {
                return false;
            }
        },
        getOneYearColor() {
            // Possible values: Y, N, ?  
            return this.default_color;
        },
        showPremarked(delineated,whitelined){
            // Possible values for delineated: Y, N, ?
            // Possible values for whitelined: Y, N, ?
            if(delineated === 'Y' || whitelined === 'Y') {
                return true;
            } else {
                return false;            
            }          
        },
        getPremarkedColor(){
            // Possible values for delineated: Y, N, ?
            // Possible values for whitelined: Y, N, ?
            return this.default_color;
        },
        showRailroad(railroad) {
            // Possible values: Y, N, U, ?
            if(railroad === 'Y') {
                return true;
            } else {
                return false;
            }
        },
        getRailroadColor() {
            // Possible values: Y, N, U, ?
            return this.default_color;
        },
        backTicketDetails() {
            this.$store.commit('SET_REVISION_DETAILS', null);
            this.$router.push({ path: `/tickets/details?tid=${this.getTicketDetails.Tickets.tid}` });
        },
        closeAllPanels() {
            this.openedPanel = null;
        },
        getLocator(locatorId){
            let locator = '';
            locator = this.$store.getters.companyUsers.find((user) => guidEqual(user.uid, locatorId));                   
            return locator?.account;       
        },
        formatCurrentUnitsWorked(unitsWorked) {
            const minutes = unitsWorked % 60;
            const hours = Math.floor(unitsWorked/60);
            let result = '';
            if(hours) {
                result = hours + 'h';
            }
            if(minutes) {
                if(hours) {
                    result += ' ';
                }
                result += minutes + 'm';
            }
            return result;
        },
    }
};
</script>

<style scoped>
    #revisions-tabs-container .v-tab {
        width: 200px;
        height: 45px;
        padding: 9px 16px;
        background: var(--ll-surface-accent);
        border-radius: 0px;
        margin: 0px 16px 2px 0px;
    }
    #revisions-tabs-container .v-item-group.v-tabs-bar  {
        border-right: 1px solid var(--ll-border);
    }
    #revisions-tabs-container .v-slide-group__content.v-tabs-bar__content {
        margin-top: 16px;
    }
    .revisions-mobile-tabs-container .v-slide-group__content.v-tabs-bar__content {
        margin-top: 2px !important;
    }
    .revisions-mobile-tabs-container .v-card .v-card__text {
        padding: 0px 16px;
    }
    #revisions-tabs-container .custom-revisions-data-table {
        font-size: 12px;
    }
    #revisions-tabs-container .custom-revisions-data-table tbody {
        vertical-align: baseline;
    }
    #revisions-tabs-container .custom-revisions-data-table td:last-child {
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 20px;
        letter-spacing: 0.004em;
        color: var(--ll-text-primary);
    }
    #revisions-tabs-container .custom-revisions-data-table td:first-child {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 20px;
        letter-spacing: 0.004em;
        color: var(--ll-text-primary);
        width: 100px;
    }
    #revisions-tabs-container .responses-revisions-container {
        background: var(--ll-surface-warning);
        border-radius: 4px !important;
        padding: 12px 12px 8px !important;
        margin: 20px;
    }
    #revisions-tabs-container .custom-responses-data-table {
        font-size: 12px;
    }
    #revisions-tabs-container .custom-responses-data-table tr {
        display: block;
        height: 20px;
    }
    #revisions-tabs-container .custom-responses-data-table tr td:first-child {
        width: 120px;
    }
    #revisions-tabs-container .custom-revisions-header {
        margin-top: 12px;
        font-size: 12px;
        display: flex;
        justify-content: space-between;
        align-items: start;
        padding: 8px 0px;
        border-bottom: 1px solid var(--ll-border);
    }
    #revisions-tabs-container .custom-revisions-header span {
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 22px;
    }
    #revisions-tabs-container .original-ticket-container {
        display: flex;
        justify-content: space-between !important;
        flex-wrap: inherit;
        height: 70px;
    }
    #revisions-tabs-container .original-ticket-container .action-btn .v-btn__content {
        color: var(--ll-text-brand) !important;
    }
    #revisions-tabs-container .ticket-details {
        font-family: Roboto Mono;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 20px;
        letter-spacing: 0.004em;
        color: var(--ll-text-primary);
        margin: 16px 0px;
    }
    .custom-tabs-mobile-screen {
        position: absolute;
        left: -4px;
    }
    .v-tabs-items {
        position: absolute;
        right: -4px;    
    }
    .expandable-mobile-view {
        position: fixed;
        z-index: 9 !important;
        background: var(--ll-surface-canvas);
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        overflow: auto;
    }
    .mobile-view-header {
        display: flex;
        align-items: center;
        padding: 16px;
        border-radius: unset !important;
        border-bottom: 1px solid var(--ll-border) !important;
        box-shadow: 0px 0px 8px -4px var(--ll-shadow) !important;
        z-index: 10;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
    }
    .expandable-mobile-view .container {
        margin-top: 65px !important;
    }
    .detail-chip {
        border-radius: 20px !important;
        height: 20px !important;
        padding:4px 4px !important;
        margin: 1px !important;       
    } 
</style>
